<script>
let globalData;
const globalCompanyProvince = [];
const globalCompanyCity = [];
const globalCompanyArea = [];

export default {
  globalData,
  globalCompanyProvince,
  globalCompanyCity,
  globalCompanyArea,
};
</script>

